import { TimeZone } from './components/Clock';

export class Configuration {
  timezone: TimeZone;

  constructor(timezone: TimeZone) {
    this.timezone = timezone;
  }

  public getTimezone(): TimeZone {
    return this.timezone;
  }

  public setTimezone(timezone: TimeZone) {
    this.timezone = timezone;
  }

  static globalConfiguration: Configuration;
  public static setConfiguration(configuration: Configuration) {
    Configuration.globalConfiguration = configuration;
  }

  public static getConfiguration(): Configuration {
    return Configuration.globalConfiguration;
  }
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/Configuration.tsx